<script>
	import { Router, Route, Link } from "svelte-navigator";
	import Landing from "./routes/Landing.svelte";
	import Store from "./routes/Store.svelte";
	import Admin from "./routes/Admin.svelte";

	// export let name;
</script>

<main>
	<Router primary={false}>
		<Route path="/">
			<Landing />
		</Route>

		<Route path="/store/*">
			<Store />
		</Route>

		<Route path="/admin/*">
			<Route path="/*">
				<Admin />
			</Route>
		</Route>
	</Router>
</main>

<style>
	main {
		text-align: center;
		max-width: 100%;
		margin: 0 auto;
		/* background: red; */
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
